"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectKeyToObjectMap = exports.mapNotNil = exports.filterNotNil = void 0;
const tslib_1 = require("tslib");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const filterNotNil = (arr) => arr.filter((el) => !lodash_1.default.isNil(el));
exports.filterNotNil = filterNotNil;
const mapNotNil = (arr, mapFn) => (0, exports.filterNotNil)(arr.map((el) => mapFn(el)));
exports.mapNotNil = mapNotNil;
function getObjectKeyToObjectMap(items, idFunc) {
    return items.reduce((agg, item) => {
        const key = idFunc(item);
        return agg.set(key, item);
    }, new Map());
}
exports.getObjectKeyToObjectMap = getObjectKeyToObjectMap;
//# sourceMappingURL=array.js.map